import get from 'lodash.get';

const getHelpCenterConfig = (rootState) => get(rootState, 'config.common.ws-helpcenter', {});

export default getHelpCenterConfig;
